import React, { useState, useEffect, useCallback } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

// ─── Toast Context ────────────────────────────────────────────────────────────
let globalToast = null;

export const showToast = (message, type = 'success', duration = 3500) => {
  if (globalToast) globalToast(message, type, duration);
};

// ─── Toast Component ──────────────────────────────────────────────────────────
export const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success', duration = 3500) => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  useEffect(() => {
    globalToast = addToast;
    return () => { globalToast = null; };
  }, [addToast]);

  const icons = {
    success: <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />,
    error:   <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" />,
    warning: <AlertCircle className="w-5 h-5 text-yellow-500 flex-shrink-0" />,
  };

  const colors = {
    success: 'border-green-200 bg-green-50 text-green-800',
    error:   'border-red-200 bg-red-50 text-red-800',
    warning: 'border-yellow-200 bg-yellow-50 text-yellow-800',
  };

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2 w-full max-w-sm px-4">
      {toasts.map(toast => (
        <div key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl border shadow-lg animate-bounce-in ${colors[toast.type] || colors.success}`}
        >
          {icons[toast.type] || icons.success}
          <p className="text-sm font-medium flex-1">{toast.message}</p>
          <button onClick={() => setToasts(p => p.filter(t => t.id !== toast.id))}>
            <X className="w-4 h-4 opacity-50 hover:opacity-100" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;